import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const Piechart = ({ numUser, numTeam }) => {
    const data = [
        { name: 'Group A', value: numUser },
        { name: 'Group B', value: numTeam },
    ];

    const COLORS = ['#FDECEB', '#EE3E38'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        percent,
        index,
        value, // Note the addition of the value parameter
    }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5; // Adjusted for better visibility
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill='black'
                textAnchor={x > cx ? 'middle' : 'middle'}
                dominantBaseline='central'>
                <tspan>{value}</tspan>
                <tspan x={x} dy={20} fontSize={10}>{` min`}</tspan>
            </text>
        );
    };

    return (
        <PieChart width={200} height={165}>
            <Pie
                data={data}
                cx={100} // Adjusted for centering
                cy={80}
                labelLine={false}
                label={renderCustomizedLabel}
                innerRadius={30}
                outerRadius={80}
                fill='#8884d8'
                dataKey='value'>
                {data.map((entry, index) => (
                    <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                    />
                ))}
            </Pie>
        </PieChart>
    );
};

export default Piechart;
